"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.impossiblePropertyDetailsSchema = exports.propertyPurchaseDateString = exports.MAX_PROPERTY_PURCHASE_YEARS = exports.MIN_PROPERTY_PURCHASE_YEARS = void 0;
const zod_1 = require("zod");
const UsageType_1 = require("../enums/UsageType");
const DwellingType_1 = require("../enums/DwellingType");
const ConstructionType_1 = require("../enums/ConstructionType");
const FoundationType_1 = require("../enums/FoundationType");
const Composition_1 = require("./Composition");
const Garage_1 = require("./Garage");
const PropertyFeatures_1 = require("./PropertyFeatures");
const numbers_1 = require("../numbers");
const constants_1 = require("../constants");
const Address_1 = require("./Address");
const dates_1 = require("../dates");
const isOnOrBeforeCurrentYear = (year) => year <= new Date().getFullYear();
exports.MIN_PROPERTY_PURCHASE_YEARS = 0;
exports.MAX_PROPERTY_PURCHASE_YEARS = 200;
exports.propertyPurchaseDateString = (0, dates_1.dateInYearsRangeStringSchemaFactory)(exports.MIN_PROPERTY_PURCHASE_YEARS, exports.MAX_PROPERTY_PURCHASE_YEARS, `Property purchase date can not be newer than ${exports.MIN_PROPERTY_PURCHASE_YEARS} years or older than ${exports.MAX_PROPERTY_PURCHASE_YEARS} years`);
exports.impossiblePropertyDetailsSchema = zod_1.z.object({
    address: zod_1.z.nullable(Address_1.impossibleAddressSchema),
    addressRaw: zod_1.z.nullable(zod_1.z.string().min(constants_1.MIN_DEFAULT_STRING_LENGTH).max(128).regex(constants_1.REGEX.defaultString)),
    ageOfRoofInYears: zod_1.z.nullable(zod_1.z.number().min(0).max(100)),
    architecturalStyle: zod_1.z.nullable(zod_1.z.string()),
    composition: zod_1.z.nullable(zod_1.z.array(Composition_1.impossibleCompositionSchema).min(1)),
    constructionType: zod_1.z.nullable(zod_1.z.nativeEnum(ConstructionType_1.ConstructionType)),
    distanceToFireDepartmentInMiles: zod_1.z.nullable(zod_1.z.number().min(1).max(100)),
    distanceToFireHydrantInFeet: zod_1.z.nullable(zod_1.z.number().min(1).max(5280)),
    dwellingType: zod_1.z.nullable(zod_1.z.nativeEnum(DwellingType_1.DwellingType)),
    estimatedReplacementCost: zod_1.z.nullable(zod_1.z.number().min(1)),
    features: zod_1.z.nullable(PropertyFeatures_1.impossiblePropertyFeaturesSchema),
    foundationType: zod_1.z.nullable(zod_1.z.nativeEnum(FoundationType_1.FoundationType)),
    garages: zod_1.z.nullable(zod_1.z.array(Garage_1.impossibleGarageSchema).min(0).max(6)),
    numberOfBathrooms: zod_1.z.nullable(zod_1.z.number().min(1).max(50)),
    numberOfFireplaces: zod_1.z.nullable(zod_1.z.number().min(0).max(70)),
    numberOfHouseholdMembers: zod_1.z.nullable(zod_1.z.number().min(1).max(20)),
    numberOfKitchens: zod_1.z.nullable(zod_1.z.number().min(1).max(8)),
    numberOfStories: zod_1.z.nullable(zod_1.z.number().min(1).max(10)),
    purchaseDate: zod_1.z.nullable(exports.propertyPurchaseDateString),
    squareFeet: zod_1.z.nullable(zod_1.z.number().min(100).max((0, numbers_1.thousand)(200))),
    usage: zod_1.z.nullable(zod_1.z.nativeEnum(UsageType_1.UsageType)),
    wallType: zod_1.z.nullable(zod_1.z.string()),
    yearBuilt: zod_1.z.nullable(zod_1.z.number().min(1638).refine(isOnOrBeforeCurrentYear)),
}).strict();
